
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError,
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_PAR_HISTORY_ACTION_TYPE = createActionTypes('parHistory/GET');

export default function getActions(dispatch) {
    return {
        getParHistory: (token, projectId, parId, isknDates) => dispatch({
            type: GET_PAR_HISTORY_ACTION_TYPE.DEFAULT, token, projectId, parId, isknDates,
            operation: GET_PAR_HISTORY_ACTION_TYPE.DEFAULT
        })
    };
}

function* workGetParHistory(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: GET_PAR_HISTORY_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_PAR_HISTORY_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_PAR_HISTORY_ACTION_TYPE);
    }
}

export function* watchGetParHistory(options) {
    yield takeEvery(
        GET_PAR_HISTORY_ACTION_TYPE.DEFAULT, workGetParHistory, options
    );
}
